import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : null;
  const articles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen pt-24 pb-16">
          <div className="max-w-6xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-2xl font-heading font-semibold text-foreground-900 mb-4">
              分类未找到
            </h1>
            <Link
              to="/"
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-24 pb-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: category.name },
            ]}
          />

          <div className="mb-12">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${category.icon} text-lg text-primary-500`}></i>
              </span>
              <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                {category.name}
              </h1>
            </div>
            <p className="text-sm text-foreground-600">{category.description}</p>
          </div>

          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-500 mb-4">该分类暂无文章</p>
              <Link
                to="/"
                className="text-sm text-primary-600 hover:text-primary-700"
              >
                返回首页浏览其他内容
              </Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}